import service from './../../http.js'


export const gettrainlist = (data) => {
	return service({
		url: '/Map/Getcapacitymodellististure',
		method: 'get'
	})
};
// 计划列表
export const getplanPagelist = (data) => {
	return service({
		url: '/Map/GetplanPagelist?pageIndex=' + data.pageIndex + "&pageSize=" + data.pageSize +
			"&status=" + data.status + "&name=" + data.name,
		method: 'get'
	})
};
// 追加计划用户
export const setPerUser = (data) => {
	return service({
		url: '/Map/PerUser',
		method: 'post',
		data
	})
};

// 开关
export const changeEnableorNot = (data) => {
	return service({
		url: '/Map/EnableorNot',
		method: 'post',
		data
	})
};
// 添加计划阶段
export const setAddstageplan = (data) => {
	return service({
		url: '/Map/Addstageplan',
		method: 'post',
		data
	})
};

// Map/GetPlanStatistics


export const getplanStatiics = () => {
	return service({
		url: '/Map/GetPlanStatistics',
		method: 'get',
	})
};


// 获取单个详情

// Map/GetPlanFrist

export const getplanfrist = (data) => {
	return service({
		url: '/Map/GetPlanFrist?SP_GUID=' + data.spguid,
		method: 'get',
	})
};

// 获取实训计划
export const getuserplanlist = (data) => {
	return service({
		url: '/Map/GetUserplanlist?pageIndex=' + data.pageIndex + "&pageSize=" + data.pageSize +
			"&SP_GUID=" + data.SP_GUID,
		method: 'get',
	})
};

//查询单个用户计划详情
export const getSingleUserDetails = (data) => {
	return service({
		url: '/Map/GetPlanUserFrist?SP_GUID=' + data.SP_GUID + "&UI_GUID=" + data.UI_GUID,
		method: 'get',
	})
};

// 追加用户
export const getperuser = (data) => {
	return service({
		url: '/Map/PerUser',
		method: 'post',
		data
	})
};

export const getputplan = (data) => {
	return service({
		url: '/Map/PutPlan',
		method: 'post',
		data
	})
};

// 能力模型

export const getGetcmpagelist = (data) => {
	return service({
		url: '/CapacityModel/Getcmpagelist?pageIndex=' + data.pageIndex + "&pageSize=" + data.pageSize +
			"&strwhere=" + data.strwhere,
		method: 'get',
	})
};


export const changeDisabled = (data) => {
	return service({
		url: '/CapacityModel/isDisabled',
		method: 'post',
		data
	})
};

export const changeDeleteCm = (data) => {
	return service({
		url: '/CapacityModel/DeleteCm',
		method: 'post',
		data
	})
};


export const changeGetprojectName = (data) => {
	return service({
		url: '/CapacityModel/GetprojectName?type=' + data,
		method: 'get',
	})
};



export const changeGetprojectType = (data) => {
	return service({
		url: '/CapacityModel/GetprojectType',
		method: 'get',
	})
};

// 实训能力模型管理
export const changecapabilitymodelm = (data) => {
	return service({
		url: '/CapacityModel/Postcapabilitymodelm',
		method: 'post',
		data
	})
};

export const changeGetcmprlist = (data) => {
	return service({
		url: '/CapacityModel/Getcmprlist?pageIndex=' + data.pageIndex + "&pageSize=" + data.pageSize +
			"&cm_guid=" + data.cm_guid,
		method: 'get',
	})
};



export const chanputcapabilitymodelm = (data) => {
	return service({
		url: '/CapacityModel/Putcapabilitymodelm',
		method: 'post',
		data
	})
};

export const cetGetPagetrends = (data) => {
	return service({
		url: '/Map/GetPagetrends?pageIndex=' + data.pageIndex + "&pageSize=" + data.pageSize,
		method: 'get',
	})
};

// 获取实训档案列表

export const getmytraindata = (data) => {
	return service({
		url: '/Chart/GetMyTrainData?ui_guid=' + data.ui_guid + "&cla_guid=" + data.cla_guid,
		method: 'get',
	})
};

// 实训记录
export const getGetTrainlogList = (data) => {
	return service({
		url: '/Chart/GetTrainlogList?ui_guid=' + data.ui_guid + "&pageIndex=" + data.pageIndex +
			"&pageSize=" + data.pageSize,
		method: 'get',
	})
};

export const GetdataClassStuinfoList = (data) => {
	return service({
		url: '/Chart/GetClassStuinfoList?cla_guid=' + data.cla_guid + "&ui_realName=" + data.ui_realName,
		method: 'get'
	})
};



export const getGetMyclaTrainData = (data) => {
	return service({
		url: '/Chart/GetMyclaTrainData?cla_guid=' + data,
		method: 'get',
	})
};


export const getGetMyTypeclaTrainData = (data) => {
	return service({
		url: '/Chart/GetMyTypeclaTrainData?si_guid=' + data,
		method: 'get',
	})
};

export const getGetMyClaTraiTypeData = (data) => {
	return service({
		url: '/Chart/GetMyClaTraiTypeData?cla_guid=' + data,
		method: 'get',
	})
};


// 删除计划
export const changeDeletePlan = (data) => {
	return service({
		url: '/Map/DeletePlan',
		method: 'post',
		data
	})
};

// 删除计划学员


export const changeDeletePlanUser = (data) => {
	return service({
		url: '/Map/DeletePlanUser',
		method: 'post',
		data
	})
};



// 班级实训档案实训统计
export const GetMyTypeclaTrainDataApi = (data) => {
	return service({
		url: '/Model/GetMyTypeclaTrainData?si_guid=' + data.si_guid + "&sx_te_guid=" + data.sx_te_guid,
		method: 'get'
	})
};


// 班级实训档案实训统计
export const GetMyclaTrainDataApi = (data) => {
	return service({
		url: '/Model/GetMyclaTrainData?cla_guid=' + data.cla_guid + "&sx_te_guid=" + data.sx_te_guid,
		method: 'get'
	})
};